// require("./qf/LocalizationForm");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
import { PredictiveSearch } from './qf/st-predictiveSearch';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
// import { ProductFormVariantSelect } from './qf/productFormVariantSelect';
// import { ClientVariantSelect } from './client/ClientVariantSelect';
import { VideoControls } from './qf/VideoControls';
import { OptionSelectors } from './qf/OptionSelectors';
import { ClientOptionSelectors } from './client/ClientOptionSelectors';
import {ProductCardSwiper} from "./client/ProductCards";


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.predictiveSearch = new PredictiveSearch();
window.modalController = new ModalController()
window.LoadMore = LoadMore;
// window.ProductFormVariantSelect = ProductFormVariantSelect;
// window.ProductFormVariantSelect = ClientVariantSelect;
window.VideoControls = new VideoControls;
window.OptionSelectors = OptionSelectors;
window.OptionSelectors = ClientOptionSelectors;
window.ProductCardSwiper = new ProductCardSwiper();
